import { hasExactly, intWithin, isPlainRecord, marketRuleSetting, resolveCountryRule, resolveMarketRule } from './market-rule-kit.js';
export const RIDER_SESSIONS_KEY = 'identity.riderSessions';
export const RIDER_SESSIONS_BOUNDS = {
    maxActive: { min: 1, max: 20 },
    listRetentionDays: { min: 0, max: 90 },
};
export const DEFAULT_RIDER_SESSIONS = { maxActive: 5, listRetentionDays: 30 };
export const STRICT_RIDER_SESSIONS = { maxActive: RIDER_SESSIONS_BOUNDS.maxActive.min, listRetentionDays: RIDER_SESSIONS_BOUNDS.listRetentionDays.min };
export const RIDER_SESSIONS_REASON_CODES = ['RIDER_SESSIONS_GOVERNED', 'RIDER_SESSIONS_DEFAULT', 'RIDER_SESSIONS_INVALID'];
export function riderSessionsIssue(v) {
    if (!isPlainRecord(v))
        return 'NOT_AN_OBJECT';
    if (!hasExactly(v, ['maxActive', 'listRetentionDays']))
        return 'UNKNOWN_OR_MISSING_MEMBER';
    const b = RIDER_SESSIONS_BOUNDS;
    if (!intWithin(v.maxActive, b.maxActive.min, b.maxActive.max))
        return 'INVALID_MAX_ACTIVE';
    if (!intWithin(v.listRetentionDays, b.listRetentionDays.min, b.listRetentionDays.max))
        return 'INVALID_LIST_RETENTION_DAYS';
    return undefined;
}
export const RIDER_SESSIONS_SPEC = {
    key: RIDER_SESSIONS_KEY,
    issue: riderSessionsIssue,
    copy: (v) => ({ maxActive: v.maxActive, listRetentionDays: v.listRetentionDays }),
    defaultValue: DEFAULT_RIDER_SESSIONS,
    strictValue: STRICT_RIDER_SESSIONS,
    reasonPrefix: 'RIDER_SESSIONS',
    constraintClass: 'privacy',
    // Never more devices, never a longer list than a layer above allows.
    tighten: (deciding, enclosing) => ({
        maxActive: Math.min(deciding.maxActive, enclosing.maxActive),
        listRetentionDays: Math.min(deciding.listRetentionDays, enclosing.listRetentionDays),
    }),
};
export function riderSessionsSetting(input) {
    return marketRuleSetting(RIDER_SESSIONS_SPEC, input);
}
/**
 * The rule `marketId` reads at `at`. A rider account is not bound to one market: the caller passes the market the app rides in. Without a market (none served
 * yet) only the platform layer applies - the registry default ({@link riderSessionsDefaultDecision}).
 */
export function resolveRiderSessions(settings, marketId, at, regionCode) {
    return resolveMarketRule(RIDER_SESSIONS_SPEC, settings, marketId, at, regionCode);
}
/**
 * The rule the rider's COUNTRY decides at `at` (the account's country) - read when the request names no market, or names one the registry does not know or
 * of another country: the country layer still bounds the account (a missing market never loosens a country's privacy rule).
 */
export function resolveRiderSessionsForCountry(settings, countryCode, at) {
    return resolveCountryRule(RIDER_SESSIONS_SPEC, settings, countryCode, at);
}
/** The decision of a request that names no market: the platform default, said so in its reason and version. */
export function riderSessionsDefaultDecision() {
    return { marketId: '', value: RIDER_SESSIONS_SPEC.copy(DEFAULT_RIDER_SESSIONS), reasonCode: 'RIDER_SESSIONS_DEFAULT', policyVersion: `${RIDER_SESSIONS_KEY}@default` };
}
export function riderSessionsWire(d) {
    return { maxActive: d.value.maxActive, listRetentionDays: d.value.listRetentionDays, reasonCode: d.reasonCode, policyVersion: d.policyVersion };
}
//# sourceMappingURL=rider-sessions-policy.js.map